module.exports = __webpack_public_path__ + "static/img/ksrk_logo5.348c2b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo5.png
// module id = orws
// module chunks = 1